// extracted by mini-css-extract-plugin
export default {"preloader-plus":"authSuccess_preloader-plus__JNMVm","preloader-custom-img":"authSuccess_preloader-custom-img__1Io8z","preloader-fade":"authSuccess_preloader-fade__zTgbn"};